module.exports = __webpack_public_path__ + "static/media/Teeth_alignment_modelling.ef8f0171.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svgicons/Teeth_alignment_modelling.svg
// module id = 940
// module chunks = 0